import React from 'react'; // Import your footer background image
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer
        className="text-white py-5" style={{ backgroundColor: "#1E567A" }}
      >
        <div className="container">
          <div className="row">

            {/* Box 1: About */}
            <div className="col-12 col-md-3 mb-4">
              <h4 className="fw-bold">The Black Stone</h4>
              {/* <h5>Address:</h5>
              <p className="small">
                50-25 65th Pl, Flushing, NY 11377, USA
              </p> */}
              {/* <h5>Phone:</h5>
              <p className="small">
                
              </p> */}
              <h5>Email:</h5>
              <p className="small">
                blackstone19750@gmail.com
              </p>
            </div>

            {/* Box 2: Links */}
            <div className="col-12 col-md-3 mb-4">
              <h5>Quick Links</h5>
              <ul className="list-unstyled small">
                <li><a href="/" className="text-white text-decoration-none">Home</a></li>
                <li><a href="/about" className="text-white text-decoration-none">about</a></li>
                {/* <li><a href="/features" className="text-white text-decoration-none">Features</a></li> */}
                {/* <li><a href="/services" className="text-white text-decoration-none">Services</a></li> */}
                <li><a href="/faq" className="text-white text-decoration-none">FAQs</a></li>
              </ul>
            </div>

            {/* Box 3: Services */}
            <div className="col-12 col-md-3 mb-4">
              <h5>Services</h5>
              <a href="/login" className="text-white text-decoration-none"><p className="small mb-1">Currency Wallet</p></a>
              <a href="/login" className="text-white text-decoration-none"><p className="small mb-1">Currency Transaction</p></a>
              <a href="/login" className="text-white text-decoration-none"><p className="small mb-1">Bitcoin Investment</p></a>
              <a href="/login" className="text-white text-decoration-none"><p className="small mb-1">Token Sale</p></a>
            </div>

            {/* Box 4: Industries */}
            {/* <div className="col-12 col-md-3 mb-4">
              <h5>Follow Us</h5>
              <div className="d-flex gap-3 mt-2">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                  style={{ fontSize: "20px" }}
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                  style={{ fontSize: "20px" }}
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white"
                  style={{ fontSize: "20px" }}
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div> */}

          </div>
        </div>
        <p className="text-white mb-0 small text-center">
          © 2025 - Black Stone™ - All Rights Reserved
        </p>
      </footer>


    </>
  );
};

export default Footer;
